import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

function loadGa(id: string) {
  if (document.getElementById("ga4-script")) return;
  const script = document.createElement("script");
  script.id = "ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  // Initialize gtag. gtag.js only processes `arguments` objects pushed to
  // dataLayer — a rest-parameter array is silently ignored and no hits are
  // ever sent, so this must stay the canonical function form.
  window.dataLayer = window.dataLayer || [];
  function gtag(..._args: any[]) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", id, { send_page_view: false });
}

export function Analytics() {
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    if (!GA_ID) return;
    if (!initialized.current) {
      loadGa(GA_ID);
      initialized.current = true;
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}
